import OutType from "./OutType.js";

// inner structure of @see https://docs.google.com/document/d/1Tzpf6Z0tahdFu27C_QiIi02eAnVv4zA7S1VMS-UCbCs/edit#bookmark=id.nu6bs7k46ux7
const Out = {
    OutTagId: { key: 'outTagId', name: 'outTagId', type: 'NUMBER' },
    OutAtBase: { key: 'outAtBase', name: 'outAtBase', type: 'NUMBER' },
    FielderId: { key: 'fielderId', name: 'fielderId', type: 'NUMBER' },
    AssistorsId: { key: 'assistorsId', name: 'assistorsId', type: 'ARRAY' },
    FielderLocation: { key: 'fielderLocation', name: 'fielderLocation', type: 'ARRAY' },
    AssistorsLocations: { key: 'assistorsLocations', name: 'assistorsLocations', type: 'ARRAY' },
    Type: { key: 'type', name: 'type', type: OutType, enumDefault: OutType.Out.key },
};

export default Out;